module.exports = __webpack_public_path__ + "5ecb1be44360a6c45dd4e63086cc9606.svg";